<template>
	<div style="height: 84vh;">
		<div class="tenant_search">

			<div class="tenant_search_1">
				<i class="ione"></i>
				<el-input placeholder="请输入房间编号" prefix-icon="el-icon-search" v-model="data.room_num"
					@keyup.enter.native="search()" @change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="请输入姓名" prefix-icon="el-icon-search" v-model="data.name" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="请输入电话" prefix-icon="el-icon-search" v-model="data.phone" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>

			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-select v-model="data.type" placeholder="用户类型" class="search_select" @change="handleStatusChange">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;"
				:style="{ marginLeft: minw ? '1rem' : '0' ,marginRight: minw ? '1rem' : '0'}">
				<div>
					<button class="search_button" @click="search()">搜索</button>
					<button class="search_button" @click="search('重置')">重置</button>
				</div>
				<div v-show="minw" style="display: flex;align-items: center;">
					<p style="color: #909399;">{{launched?'收起':'展开'}}</p>
					<i size="mini" :class="launched?'el-icon-arrow-up':'el-icon-arrow-down'" @click="launched=!launched"></i>
				</div>

			</div>

		</div>
		<ListingButton :lists="lists" @add='add' @disable='disable' @recovery='recovery' @delete='BatchDelete'>
		</ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@SwitchStatus="SwitchStatus" style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
		<Mycell :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@SwitchStatus="SwitchStatus" style="padding-bottom: 4rem;"></Mycell>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import Mycell from "@/components/My_cell/index.vue"
	import {
		user_list,
		user_hard_delete,
		user_switch
	} from "@/api/api.js"

	export default {
		data() {
			return {
				name: 'user',
				lists: [{
					name: '添加',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}, {
					name: '禁用',
					type: 'warning',
					icon: 'el-icon-remove-outline',
					funt: 'disable'
				}, {
					name: '恢复',
					type: 'success',
					icon: 'el-icon-refresh-right',
					funt: 'recovery'
				}, {
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete',
					funt: 'delete'
				}, ],
				tableData: [],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '姓名',
					value: 'name'
				}, {
					label: '房间编号',
					value: 'room_num'
				}, {
					label: '性别',
					value: 'sex'
				}, {
					label: '身份证号',
					value: 'card_id'
				}, {
					label: '电话',
					value: 'phone'
				}, {
					label: '门禁卡',
					value: 'doorcard'
				}, {
					label: '有效日期',
					value: 'validity'
				}, {
					label: '绑定小程序',
					value: 'openid'
				}, {
					label: '绑定公众号',
					value: 'wxopenid'
				}, {
					label: '用户类型',
					value: 'type'
				}, {
					label: '状态',
					value: 'status'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15,
					name: '',
					room_num: '',
					phone: '',
					type: ''
				},
				options: [{
					value: 1,
					label: '租客'
				}, {
					value: 2,
					label: '同住人'
				}, {
					value: 3,
					label: '访客'
				}, {
					value: 4,
					label: '过往租客'
				}, ],
				minw: JSON.parse(sessionStorage.getItem('minw')),
				launched: !JSON.parse(sessionStorage.getItem('minw'))
			}
		},
		methods: {
			search(resetting) {

				if (resetting != undefined) {
					this.data.room_num = ''
					this.data.name = ''
					this.data.phone = ''
					this.data.type = ''
					this.contractlistcontractlist(this.data.page)
				} else {
					sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 1);
					this.contractlistcontractlist('搜索')
				}
			},

			handleStatusChange() {
				sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 0);
			},

			contractlistcontractlist(value) {
				if (value == '搜索') {
					this.data.page = 1
				} else if (sessionStorage.getItem(this.$router.currentRoute.path + 'search_status') == 1) {
					this.data.page = value ? value : this.data.page
				} else {
					this.data = {
						page: value ? value : this.data.page,
						limit: 15
					}
				}
				user_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {

						res.data.list.forEach(item => {
							item.wxopenid = (!item.wxopenid || !String(item.wxopenid).trim()) ? '否' : '是';
							item.openid = (!item.openid || !String(item.openid).trim()) ? '否' : '是';
						});
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '添加用户'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '用户编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				user_hard_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				user_hard_delete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			// 状态更改
			SwitchStatus(value) {
				const {
					id,
					status
				} = value
				console.log('id:', id, 'status', status);
				user_switch({
					ids: [`${id}`],
					status: `${status}`
				}).then(res => {
					this.Messages(res)
					if (res.status != 200) {
						user_list(this.data).then(res => {
							console.log('res', res);
							if (res.status == 200) {
								this.tableData = res.data.list
								this.total = res.data.count
							}
						})
					}
				})
			},
			//批量禁用
			disable() {
				user_switch({
					ids: this.multipleSelection,
					status: '0'
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
					this.multipleSelection = []
				})
			},
			//批量启用
			recovery() {
				user_switch({
					ids: this.multipleSelection,
					status: '1'
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
					this.multipleSelection = []
				})
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},

		},
		components: {
			MyTable,
			ListingButton,
			MyDialog,
			Mycell
		},
		created() {
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
		/* min-width: 20rem; */
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;
		/* min-width: 14rem; */

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		min-width: 0.375rem;
		max-width: 1rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search> :nth-child(4) i {}


	.tenant_search_1 .el-input {
		width: 9rem;
		/* min-width: 12rem; */
		font-size: 0.8rem !important;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}

	>>>.search_select .el-input {
		width: 100% !important;
		font-size: 0.8rem !important;
	}
</style>